import React, { AriaAttributes } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

interface CommonProps {
  ['aria-current']?: AriaAttributes;
}

export type LinkIsHTMLAnchorTag = React.ComponentPropsWithoutRef<'a'> & {
  activeClassName?: never;
  activeStyle?: never;
  exact?: never;
  href?: string;
  location?: never;
  replace?: never;
  strict?: never;
  to?: never;
};

type ConditionalProps = NavLinkProps | LinkIsHTMLAnchorTag;

export type DeprecatedLinkProps = CommonProps & ConditionalProps;

/** @deprecated use NavLink, Link, NavButton or Button component instead */
const DeprecatedLink = (props: DeprecatedLinkProps) => {
  const isNavLink = typeof props.to !== 'undefined';

  if (isNavLink) {
    const { to, children, ...rest } = props;
    return (
      <NavLink to={to} {...rest}>
        {children}
      </NavLink>
    );
  } else {
    const { children, ...rest } = props;
    return <a {...rest}>{children}</a>;
  }
};

export default DeprecatedLink;

DeprecatedLink.displayName = 'Link';
